import EnvelopeTrack from './EnvelopeTrack.js';
import {setEnvelopePatternLocks} from 'actions/index.js';
import {moveKey, deleteKey} from 'utils/objectMover.js';

class EnvelopesTrack {
    constructor(sequencerEngine, subSequence) {
        this.sequencerEngine = sequencerEngine;
        this.subSequence = subSequence;
        this.store = sequencerEngine.store;
        this.envelopes = getEnvelopeTracks(sequencerEngine, this);
        this.currentPattern = 0;
    }

    switchToPattern(currentPattern, i) {
        this.currentPattern = i;
        return this.updateRedux(currentPattern, i);
    }

    updateRedux(currentPattern, newPattern) {
        let parameters = this.getAllPatternLockedParameters(currentPattern, newPattern);
        let bulkUpdate = [];
        for (let i in parameters) {
            let parameter = parameters[i];
            let update = parameter.updateRedux(true);
            if (update !== undefined) {
                bulkUpdate[update.id] = update.value;
            }
        }
        return bulkUpdate;
    }

    deletePattern(i) {
        this.store.dispatch(setEnvelopePatternLocks(
            this.subSequence.id,
            deleteKey(i, this.patternLocks)));
    }

    get patternLocks() {
        let locks = this.store.getState().tracks.envelopePatternLocks[this.subSequence.id] || {};
        return {... locks};
    }

    movePatternTo(from, to) {
        this.store.dispatch(setEnvelopePatternLocks(
            this.subSequence.id,
            moveKey(from, to, this.patternLocks)));
    }

    getAllPatternLockedParameters(currentPattern, newPattern) {
        let parameters = [];
        this.envelopes.forEach(
            envelopeTrack =>
                envelopeTrack.envelope.parameters
                .filter(parameter => parameter.hasPatternLockedValues(currentPattern, newPattern))
                .forEach(parameter => parameters.push(parameter)));
        return parameters;
    }

    newPattern(numOfPatterns) {
        let newPatternNumber = numOfPatterns - 1;
        this.getAllPatternLockedParameters()
            .forEach(parameter => parameter.newPattern(this.currentPattern, newPatternNumber));
            
        let patternLocks = this.patternLocks;
        patternLocks[newPatternNumber] = this.patternLocked;
        this.store.dispatch(setEnvelopePatternLocks(
            this.subSequence.id, patternLocks));
    }

    get patternLocked() {
        return this.patternLocks[this.currentPattern] || false;
    }

    set patternLocked(locked) {
        let patternLocks = this.patternLocks;

        patternLocks[this.currentPattern] = locked;
        this.store.dispatch(setEnvelopePatternLocks(
            this.subSequence.id,
            patternLocks));
        this.updateRedux();
    }

    togglePatternLocked() {
        this.patternLocked = !this.patternLocked;
    }
}

function getEnvelopeTracks(sequencerEngine, envelopesTrack) {
    let envelopes = [];
    envelopes.push(new EnvelopeTrack(
        sequencerEngine, sequencerEngine.mixSession, envelopesTrack, 1));
    envelopes.push(new EnvelopeTrack(
        sequencerEngine, sequencerEngine.mixSession, envelopesTrack, 2));
    envelopes.push(new EnvelopeTrack(
        sequencerEngine, sequencerEngine.mixSession, envelopesTrack, 3));
    envelopes.push(new EnvelopeTrack(
        sequencerEngine, sequencerEngine.mixSession, envelopesTrack, 4));
    return envelopes;
}

export default EnvelopesTrack;
